import { BCMSRecord, DisabledPrompt, StateManager, useBCMSContext, useModel, useStateManager } from "@bcm-dev/bcms-vite";
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView, WidgetContainer, WidgetView } from 'components/shared';
import Classes from "model";
import React from 'react';
import { SVGAsset } from 'res';
import NoWireTransferTableRow from '../NoWireTransferTableRow';
import "./styles.css";
import "./mobile.css";
import { ScheduledWireTableRow } from "./components/ScheduledWireTableRow";
import { MobileScheduledWireTableRow } from "./components/MobileScheduledWireTableRow";

/**
 * @function ScheduledWiresWidget
 * @return {React.Component}
 * @exported true
 * @description The widget that shows the Scheduled wires
 */

export default function ScheduledWiresWidget(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
  });

  return (
    <StateManager state={{ data, ui }} controller={controller}>
      <WidgetContent />
    </StateManager>
  )
}

export const getDefaultData = () => ({
  // no used data for now
});

export const getDefaultUI = () => ({
  // no ui changes for now
});

function WidgetContent(props) {
  const { data } = useStateManager();
  const { branding } = useModel() ?? {};
  const { options } = branding ?? {};
  const hasNotifyPayeeColumn = options.scheduled_wires_notify_payee_abi22 === "true";
  const noWiresRowColSpan = hasNotifyPayeeColumn ? "6" : "5";

  const scheduledWireRows = data.scheduledWires.reduce((acc, scheduledWire, index) => {
    acc.push(<ScheduledWireTableRow key={scheduledWire.id} scheduledWire={scheduledWire} rowId={index} />);
    return acc;
  }, []);

  const mobileScheduledWireRows = data.scheduledWires.reduce((acc, scheduledWire) => {
    acc.push(<MobileScheduledWireTableRow key={scheduledWire.id} scheduledWire={scheduledWire} />);
    return acc;
  }, []);

  return (
    <WidgetContainer className="scheduled-wire-widget">
      <WidgetView text="Scheduled Wires" dataPoint="ScheduledWires">
        <div className="show-on-desktop">
          <TableView>
            <TableColumnContainer>
              <TableColumnView className="text-left ref-number-text" text="Ref #" />
              <TableColumnView className="text-left payee-text" text="Payee" />
              {hasNotifyPayeeColumn && <TableColumnView className="text-left notify-payee-text" text="Notify Payee" />}
              <TableColumnView className="text-left schedule-text" text="Schedule" />
              <TableColumnView className="text-left amount-text" text="Amount" />
              <TableColumnView className="text-left next-wire-date-text" text=
                {<>Next Wire Date
                  <DisabledPrompt>
                    <SVGAsset id="ArrowUpIcon" className="clickable" />
                  </DisabledPrompt>
                </>}
              />
            </TableColumnContainer>
            <TableBody>
              {scheduledWireRows.length > 0 ? scheduledWireRows : <NoWireTransferTableRow colspan={noWiresRowColSpan} />}
            </TableBody>
          </TableView>
        </div>


        {/* Mobile Scheduled wires table view */}
        <div className="mobile-scheduled-wire-table show-on-mobile">
          {mobileScheduledWireRows.length > 0 && mobileScheduledWireRows}
        </div>

        <div className="show-on-mobile">
          <TableView className="scheduled-wires-table">
            <TableBody>
              {mobileScheduledWireRows.length === 0 && <NoWireTransferTableRow colspan={noWiresRowColSpan} />}
            </TableBody>
          </TableView>
        </div>
      </WidgetView>
    </WidgetContainer>
  );
}



export function getScheduledDescription(wire) {
    const scheduledWire = wire ?? {};

    if (scheduledWire.frequency === "weekly") {
        if (scheduledWire.frequencyType === "noEndDate") {
            return `Every week, starting on ${scheduledWire.date.format("m/d/Y")}`;
        } else if (scheduledWire.frequencyType === "endAfter") {
            return `Every week, starting on ${scheduledWire.date.format("m/d/Y")} and ending after ${scheduledWire.recurringNumberOfTransfers} occurrences`;
        }
    } else if (scheduledWire.frequency === "monthly") {
        if (scheduledWire.frequencyType === "noEndDate") {
            return `Every month, starting on ${scheduledWire.date.format("m/d/Y")}`;

        } else if (scheduledWire.frequencyType === "endAfter") {
            return `Every month, starting on ${scheduledWire.date.format("m/d/Y")} and ending after ${scheduledWire.recurringNumberOfTransfers} occurrences`;
        }
    }

}